import { newOrderComponents } from "./components";
import { newOrderDialogs } from "./dialogs";
import newOrderDetails from "./newOrderDetails.json";

export const newOrdersPT = {
	...newOrderComponents,
	...newOrderDialogs,
	newOrderDetails,
};
